import type { ReactNode } from 'react';

export const symbol_titlecase: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M354-283v-373H247q-9 0-16-6.5t-7-15.5q0-9 7-15.5t16-6.5h263q9 0 15.5 6.5T532-678q0 9-6.5 15.5T510-656H402v373q0 10-7 16.5t-17 6.5q-10 0-17-6.5t-7-16.5Zm261-255h-36q-8 0-13.5-5.5T560-557q0-8 5.5-13.5T579-576h36v-65q0-9 6.5-15.5T637-663q9 0 15.5 6.5T659-641v65h56q8 0 13.5 5.5T734-557q0 8-5.5 13.5T715-538h-56v189q0 26 12.5 42.5T704-290q5 0 9-.5t9-.5q8 0 12.5 5.5T739-271q0 8-5 13t-15 7q-5 2-10.5 1.5T698-250q-35 0-59-25t-24-61v-202Z"
		/>
	</svg>
);
